export default "__VITE_ASSET__AuPz4p8X__"